export default __webpack_public_path__ + "img/WB_RT.8b46f71fc1e0fb5152b7532c0c52e049.jpg";